<template>
  <ItemPage
    :title="titlePage"
    size="md"
    :actions="actions"
  >
    <div v-if="choiceGroup">
      <QuestionsList
        :group-id="parseInt(groupId)"
        :choice-id="parseInt(choiceId)"
      />
    </div>
  </ItemPage>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import QuestionsList from './components/QuestionsList.vue'
import ItemPage from '@/components/pages/ItemPage.vue'

export default {
  components: {
    QuestionsList,
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      exam: null,
      choiceGroup: null,
      loading: false,
      titlePage: 'Subgrupo'
    }
  },

  computed: {
    examId () {
      return this.$route.params.examId
    },
    groupId () {
      return this.$route.params.groupId
    },
    choiceId () {
      return this.$route.params.choiceId
    },

    actions () {
      return [
      ]
    }
  },
  watch: {
    title () {
      this.checkUpdate()
    },
    caption () {
      this.checkUpdate()
    }
  },
  async mounted () {
    this.fetchAll()
  },
  methods: {
    async fetchAll () {
      // await this.getExams()
      await this.getQuestionGroupChoices()
    },

    // async getExams () {
    //   this.loading = true
    //   try {
    //     this.exam = await this.$api.getExams(this.examId)
    //   } catch (e) {
    //     this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar obter avaliação.', color: 'red' })
    //     this.getErrors(e)
    //   } finally {
    //     this.loading = false
    //   }
    // },

    async getQuestionGroupChoices () {
      this.loading = true
      try {
        this.choiceGroup = await this.$api.getQuestionGroupChoices(this.choiceId)
        this.titlePage = 'Subgrupo: ' + this.choiceGroup.title
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar obter grupo de questões.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
